import { render } from "./indexdoctor.vue?vue&type=template&id=c6bebeea"
import script from "./indexdoctor.vue?vue&type=script&lang=js"
export * from "./indexdoctor.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__